import { BD_CHART_TOOLTIP_DEFAULT } from '@bindoc-projects/chart-domain-lib';
import { BdNumberFormatter } from '@bindoc-projects/util-domain-lib';
import type {
  ChartDataset,
  ChartOptions,
  ChartType,
  ScaleOptions,
  TooltipItem,
} from 'chart.js';
import type {
  LabelOptions,
  Options as DatalabelsOptions,
} from 'chartjs-plugin-datalabels/types/options';

/**
 * `ChartDataset` widened with chartjs-plugin-datalabels' per-dataset options.
 *
 * The plugin ships that property as a `declare module 'chart.js'` augmentation in
 * its *entry* module, so picking it up would mean importing the plugin itself —
 * exactly the eager-path edge this library must not have. Only the leaf option
 * types are imported and the dataset is widened here instead, the same way
 * chart-domain-lib's `applyDatalabelsOptions` widens `options.plugins`.
 */
export type HtmDatalabelsChartDataset<TType extends ChartType = ChartType> =
  ChartDataset<TType> & { datalabels?: DatalabelsOptions };

export const COST_SAVINGS_CHART_DATASET_DATALABELS: {
  labels: { [labelName: string]: LabelOptions };
} = {
  labels: {
    current: {
      display: 'auto',
      formatter: (value) => BdNumberFormatter.format(value),
      font: {
        family: 'Montserrat',
        size: 10,
        // weight: 'bold'
      },
      // borderRadius: 2,
      color: '#fff',
      anchor: 'center',
      align: 'center',
      // offset: 16
    },
  },
};

export const COST_SAVINGS_CHART_OPTIONS: ChartOptions | any = {
  maintainAspectRatio: false,
  aspectRatio: 3 / 4,
  scales: {
    x: {
      // ...BD_NUMERIC_CHART_AXIS_OPTIONS_DEFAULT,
      type: 'linear',
      stacked: true,
      gridLines: {
        drawBorder: false,
      },
      scaleLabel: {
        display: true,
        labelString: 'Fälle',
      },
    } as ScaleOptions<'linear'>,
    y: {
      stacked: true,
    },
  },
  layout: {
    padding: {
      top: 40,
    },
  },
  plugins: {
    tooltip: {
      ...BD_CHART_TOOLTIP_DEFAULT,
      callbacks: {
        label(tooltipItem: TooltipItem<ChartType>): string | string[] {
          return BdNumberFormatter.format(tooltipItem.raw as number);
        },
      },
    },
    legend: {
      // display: false,
      position: 'bottom',
    },
    annotation: {},
  },
};
